export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'kulanceBreadcrumbTODO';
export const NAME = 'Kulance';
